"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleExteriorColor = void 0;
const core_1 = require("@angular/core");
let VehicleExteriorColor = class VehicleExteriorColor {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleExteriorColor.prototype, "vehicle", void 0);
VehicleExteriorColor = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-exterior-color',
        template: `
    <span
      class="color-tag"
      [ngClass]="vehicle.vehicleData.features.exteriorColor?.color"
    >
      {{ vehicle.vehicleData.features.exteriorColor?.manufacturerCode || '-' }}

      <ng-template [ngIf]="vehicle.vehicleData.features.exteriorColor?.manufacturerName">
        <svg class="ab-icon cell-icon vmin-tablet-xl"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content">
          {{ vehicle.vehicleData.features.exteriorColor?.manufacturerName }}
        </div>
      </ng-template>

      <div class="color-circle" *ngIf="vehicle.vehicleData.features.exteriorColor?.color">
        <i class="fa-solid fa-droplet"></i>
      </div>
    </span>
  `,
    })
], VehicleExteriorColor);
exports.VehicleExteriorColor = VehicleExteriorColor;
